import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import { isHelixOnlyHub } from 'utils/helix';
import config from 'utils/config';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Card from 'components/Card';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import Panel from 'components/Panel';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var HelixEmailLink = function HelixEmailLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    href: "mailto:helix@5app.com",
    children: children
  });
};
export var SettingsLink = function SettingsLink(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(TextLink, {
    as: Link,
    to: "/settings",
    children: children
  });
};
export function HowHelixWorksText(_ref3) {
  var headingProps = _ref3.headingProps,
    stackProps = _ref3.stackProps;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({
      as: "h3",
      size: "medium",
      mb: "m"
    }, headingProps), {}, {
      children: t('skills_empty_how_helix_works_title')
    })), /*#__PURE__*/_jsxs(Stack, _objectSpread(_objectSpread({
      spacing: "s"
    }, stackProps), {}, {
      children: [/*#__PURE__*/_jsxs(Trans, {
        i18nKey: "skills_empty_how_helix_works_text_1",
        children: ["Helix will attend any meeting to which", /*#__PURE__*/_jsx(HelixEmailLink, {
          children: "helix@5app.com"
        }), "is invited."]
      }), ['skills_empty_how_helix_works_text_2', 'skills_empty_how_helix_works_text_3', 'skills_empty_how_helix_works_text_4', 'skills_empty_how_helix_works_text_5'].map(function (key) {
        return /*#__PURE__*/_jsx(Text, {
          children: t(key)
        }, key);
      })]
    }))]
  });
}
export function HelixChangeMyMindText(_ref4) {
  var headingProps = _ref4.headingProps,
    stackProps = _ref4.stackProps;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Heading, _objectSpread(_objectSpread({
      as: "h3",
      size: "medium",
      mb: "m"
    }, headingProps), {}, {
      children: t('skills_empty_mind_changed_title')
    })), /*#__PURE__*/_jsx(Stack, _objectSpread(_objectSpread({
      spacing: "s"
    }, stackProps), {}, {
      children: ['skills_empty_mind_changed_text_1', 'skills_empty_mind_changed_text_2', 'skills_empty_mind_changed_text_3', 'skills_empty_mind_changed_text_4'].map(function (key) {
        return /*#__PURE__*/_jsx(Text, {
          children: t(key)
        }, key);
      })
    }))]
  });
}
function WelcomePage(_ref5) {
  var user = _ref5.user;
  var _useTranslation3 = useTranslation(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_jsx(PageSection, {
    flush: true,
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "l",
      maxWidth: 860,
      mb: "m",
      mt: isHelixOnlyHub ? 'm' : '0',
      children: [user && /*#__PURE__*/_jsx(UserPageHeader, _objectSpread({}, user)), /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('skills_empty_welcome_title')
      }), /*#__PURE__*/_jsxs(Card, {
        p: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "medium",
          mb: "m",
          children: t('skills_empty_get_started_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_get_started_text_1')
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_get_started_text_2",
            children: ["It couldn\u2019t be easier \u2013 simply invite", /*#__PURE__*/_jsx(HelixEmailLink, {
              children: "helix@5app.com"
            }), "to your next meeting and it will automatically start tracking your skills."]
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_get_started_text_3')
          })]
        })]
      }), config.userCalendarIntegration && /*#__PURE__*/_jsxs(Card, {
        p: "m",
        children: [/*#__PURE__*/_jsx(Heading, {
          as: "h3",
          size: "medium",
          mb: "m",
          children: t('skills_empty_auto_join_title')
        }), /*#__PURE__*/_jsxs(Stack, {
          spacing: "s",
          children: [/*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_auto_join_text_1')
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_auto_join_text_2",
            children: ["No need to manually invite", /*#__PURE__*/_jsx(HelixEmailLink, {
              children: "helix@5app.com"
            }), "to the meeting - Helix will join based on your preferences."]
          }), /*#__PURE__*/_jsxs(Trans, {
            i18nKey: "skills_empty_auto_join_text_3",
            children: ["You can edit your meeting preferences or unlink your calendar at any time via your", /*#__PURE__*/_jsx(SettingsLink, {
              children: "Settings"
            }), "page"]
          }), /*#__PURE__*/_jsx(Text, {
            children: t('skills_empty_auto_join_text_4')
          }), /*#__PURE__*/_jsx(Panel, {
            align: "center",
            flush: true,
            children: /*#__PURE__*/_jsx(Button, {
              icon: "calendar",
              variant: "primary",
              as: Link,
              to: "/settings",
              children: t('actions_go_to_settings')
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(Card, {
        p: "m",
        children: /*#__PURE__*/_jsx(HowHelixWorksText, {})
      }), /*#__PURE__*/_jsx(Card, {
        p: "m",
        children: /*#__PURE__*/_jsx(HelixChangeMyMindText, {})
      })]
    })
  });
}
export default WelcomePage;